import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function InfoIcon({ width, height, viewBox, style, className, rectFill }: IIcon) {
    const newViewProps = '0 0 640 640.173' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <rect
                    width="100%"
                    height="100%"
                    x="0"
                    y="0"
                    rx="50%"
                    ry="50%"
                    fill={rectFill}
                ></rect>
                <path
                    d="M321.812,185.468c30.226,0,48.427-20.268,48.282-45.121c-0.744-25.432-18.512-44.832-47.528-44.688
		c-29.037,0.145-47.848,19.896-47.848,45.287C274.873,165.737,293.374,185.777,321.812,185.468z"
                />
                <path
                    d="M318.352,0.004C141.576,0.872-0.905,144.974,0.004,321.781c0.898,176.663,145.032,319.298,321.808,318.389
		c176.766-1.053,319.235-145.031,318.183-321.838C639.106,141.503,495.107-0.925,318.352,0.004z M321.512,587.962
		C173.464,588.707,53.11,469.417,52.201,321.451C51.447,173.547,170.613,52.976,318.651,52.17
		c147.883-0.847,268.537,118.567,269.3,266.305C588.696,466.544,469.385,587.053,321.512,587.962z"
                />
                <polygon
                    points="367.987,273.313 367.987,244.885 367.987,221.147 244.544,221.147 244.544,273.313 
		278.385,273.313 278.385,460.078 243.129,460.078 243.129,510.323 398.068,510.323 398.068,460.078 367.987,460.078 	"
                />
            </g>
        </Icon>
    );
}
